import { TextField } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';

type WizardNumericFieldProps = {
  label: string;
  name: string;
  helperText?: string;
  float?: boolean;
};

export const WizardNumericField = ({
  label,
  name,
  helperText = '',
  float = false,
}: WizardNumericFieldProps) => {
  const {
    control,
    formState: { errors },
  } = useFormContext();

  const errorMessage = (errors[name]?.message as string) || helperText;
  const isError = !!errors[name];

  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => {
        return (
          <TextField
            {...field}
            type="number"
            label={label}
            helperText={errorMessage}
            error={isError}
            fullWidth
            value={field.value ?? ''}
            onChange={(e) => {
              const value = e.target.value;
              
              if(!value) return field.onChange(value);

              if(float) {
                field.onChange(parseFloat(value));
              } else {
                field.onChange(parseInt(value));
              }
            }}
            onWheel={(e) => {
              (e.target as HTMLInputElement).blur();
            }}
          />
        );
      }}
    />
  );
};

